module.exports = __webpack_public_path__ + "static/mobile-bloom-da0edec25c94fd896e7f676a0e53d4b7.webp";